export const PageHeader = ({ overline, title, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 rise">
    <div>
      <p className="font-mono text-xs font-bold tracking-[0.2em] text-emerald-600 uppercase">{overline}</p>
      <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 mt-1">{title}</h2>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
